<template lang="pug">
  div
    .placeholder(v-if='loading')
    .content.year(v-if='!loading')
      .grid
        .col-3_xs-12.titles
          router-link(:to={path: '/exhibitions'})
            h2
              | exhibitions
          h4.status
            | {{ $route.params.year }}
        .col-9_xs-12(v-if="exhibitions.length > 0")
          .grid.no-margin
            .col-6_xs-12(v-for="exhibition in exhibitions")
              router-link(:to="{path: year + '/' + exhibition.uid}")
                .screen-small(v-if="hero(exhibition)")
                  visual(
                    :image="hero(exhibition)"
                    background="cover"
                    role="img"
                    :aria-label="altText(exhibition)"
                  )
                  .captions
                    h1.title
                      | {{ exhibition.content.title }}
                    h2.dates
                      | {{ date(exhibition) }}
                .screen-small(v-if="!hero(exhibition)")
                  visual(
                    image="/static/images/sun.jpg"
                    background="cover"
                    role="img"
                    :aria-label="altText(exhibition)"
                  )
                  .noimagecaptions
                    h1.title
                      | {{ exhibition.content.title }}
                    h2.dates
                      | {{ date(exhibition) }}
        .col-9_xs-12(v-else)
          h2.standin
            | Full exhibitions list coming soon ...
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'exhibitions-year',
  mixins: [DataMixin, ComponentMixin],

  created () {
    this.key = 'exhibitions/' + this.year
    this.requestData(this.key, 'children')
  },

  methods: {
    // hero: function (image, files) {

    //   return files.find(item => item.filename === image)
    // },

    hero: function (exhibition) {
      if (exhibition.hero_cropped_sq !== '') {
        return exhibition.hero_cropped_sq.url
      } else if (exhibition.main_image !== '') {
        return exhibition.main_image.url
      } else {
        return false
      }
    },

    altText: function (exhibition) {
      return exhibition.title
    },

    startDate: function (exhibition) {
      return exhibition.content.start_date
    },

    endDate: function (exhibition) {
      return exhibition.content.end_date
    },

    startYear: function (exhibition) {
      return exhibition.content.start_year
    },

    endYear: function (exhibition) {
      return exhibition.content.end_year
    },

    date: function (exhibition) {
      const endDate = this.endDate(exhibition) + ', ' + this.endYear(exhibition)
      let startDate = startDate = this.startDate(exhibition)
      if (this.endYear(exhibition) !== this.startYear(exhibition)) {
        startDate = this.startDate(exhibition) + ', ' + this.startYear(exhibition)
      }
      return startDate + ' - ' + endDate
    }
  },

  computed: {
    exhibitions: function () {
      return this.loadedData[this.key]
    },

    year: function () {
      return this.$route.params.year
    },

    content: function () {
      return this.exhibition.content
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/main'
  .content
    &.year
      .titles
        h2, h4
          padding-left: 0
      .status
        color: #FD0000
        font-size: 2rem
      .screen-small
        @include respond-to(xs)
          padding-bottom: 52vW !important
        .vv-image
          background-size: cover
          background-repeat: no-repeat
          @include respond-to(xs)
            padding-bottom: 52vW !important
        &:hover > .captions
          opacity: 1
          @include transition(opacity, 0.2s, ease-in-out)
        .captions
          opacity: 0
          background-color: rgba(255, 255, 255, 0.9)
        .noimagecaptions
          background-color: rgba(255, 255, 255, 0)
        .captions, .noimagecaptions
          width: 100%
          height: 100%
          position: absolute
          bottom: 0
          @include transition(opacity, 0.2s, ease-in-out)
          @include respond-to(xs)
            height: 50% !important
            opacity: 1 !important
            background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.75)) !important
            color: white !important
          h1
            position: absolute
            bottom: 0
            font-size: 4rem
            padding-left: 3.3rem
            padding-right: 3.3rem
            padding-bottom: 7rem !important
            letter-spacing: $kerningTight
            line-height: 95%
            @include respond-to(xs)
              font-size: 2.5rem !important
              padding-left: 1rem !important
              padding-bottom: 4rem !important
              letter-spacing: $kerningTightMobile !important
          h2
            position: absolute
            bottom: 0
            font-size: 2.5rem
            padding-left: 3.3rem
            padding-bottom: 3.3rem
            letter-spacing: $kerningMidTight
            @include respond-to(xs)
              font-size: 2rem !important
              letter-spacing: $kerningTightMobile !important
              padding-left: 1rem !important
              padding-bottom: 1rem !important
          h1, h2
            @include respond-to(xs)
              width: 90%
    .standin
      margin-top: 14rem
</style>



// WEBPACK FOOTER //
// ExhibitionsYear.vue?f5724d22